import dayjs from "dayjs";
import Util from "../../libs/util/Util";
import RippleManagerClass from "./RippleManagerClass";
import CalenderSlideClass from "./CalenderSlideClass";
import ThingsManagerClass from "../../libs/base/ThingsManagerClass";

/**
 * カレンダー　基礎クラス
 */
export default class CalenderBaseClass extends ThingsManagerClass{
    constructor(_target){
        super();
        this.name = "CalenderBaseClass";

        this.target = _target;
        this.isSlide = true;
    }

    onCreate() {
        super.onCreate();

        this.insertTarget = $(".wrap",this.target);
    }

    onClear(){
        //console.log(this.name,"onClear",this.things.calenderSlide);
        if(this.things.calenderSlide){
            this.things.calenderSlide.onRemove();
            this.things.calenderSlide = null;
        }
        this.insertTarget.empty();
    }

    onSlideMove(_point){
        if(this.isSlide){
            const box = this.things.calenderSlide.$items;
            const index = box.index(this.$days.eq(_point).closest(".box"));
            if(this.things.calenderSlide.isSlide) this.things.calenderSlide.justMove(index);
        }
    }

    onSlideMoveToMonth(_month){
        if(this.isSlide){
            const box = this.things.calenderSlide.$items;
            const index = box.index(box.filter('[data-month='+_month+']'));
            if(this.things.calenderSlide.isSlide) this.things.calenderSlide.move(index);
        }
    }

    /**
     * カレンダーの表示範囲を設定
     * @param _data:{calender_start:dayjs or String,calender_end:dayjs or String}
     */
    onSetData(_data){
        //console.log(this.name,_data);

        const start = (typeof _data.calender_start == "string")? dayjs(_data.calender_start) : _data.calender_start;
        const end = (typeof _data.calender_end == "string")? dayjs(_data.calender_end) : _data.calender_end;

        let html = '';

        let monthCount = end.diff(start,'month');
        if(end.get('date') < start.get('date')) monthCount += 1;
        //console.log(start,end,monthCount,start.get('date'),end.get('date'));

        //console.log(start.get('date'));

        for(let i=0;i<=monthCount;i++){
            let tmpDays = start.add(i,'month');
            let tmpStartDays = tmpDays.startOf('month');
            let tmpEndDays = tmpDays.endOf('month');
            const year = tmpDays.get('year');
            const month = tmpDays.get('month') + 1;
            html += '<section class="box" data-month="'+month+'"><h4>'+year+'年'+month+'月</h4>';

            html += '<ul><li>日</li><li>月</li><li>火</li><li>水</li><li>木</li><li>金</li><li>土</li>';

            let liCount = 0;
            const weekCount = 7;
            //console.log(tmpDays,tmpStartDays,tmpEndDays);
            const dateCount = tmpEndDays.get('date');
            const startEmptyCount = tmpStartDays.get('day');
            //console.log(startEmptyCount);
            for(let a=0;a<startEmptyCount;a++){
                if(liCount%weekCount === 0) html += '</ul><ul>';

                html += '<li></li>';

                liCount++;
            }

            const startDate = start.get('date');
            const endDate = end.get('date');

            for(let a=0;a<dateCount;a++){
                if(liCount%weekCount === 0) html += '</ul><ul>';
                const date = a+1;
                if((i===0 && date < startDate) || (i===monthCount && date > endDate)) {
                    html += '<li><span>' + date + '</span></li>';
                } else {
                    html += '<li><a href="" class="js-ripple" data-date="'+year+'/'+Util.zeroPadding(month)+'/'+Util.zeroPadding(date)+'"><span class="inner"><span class="day">'+date+'</span><span class="price"></span></span></a></li>';
                }

                liCount++;
            }

            const endEmptyCount = 6 - tmpEndDays.get('day');
            for(let a=0;a<endEmptyCount;a++){
                if(liCount%weekCount === 0) html += '</ul><ul>';
                html += '<li></li>';
                liCount++;
            }

            html += '</ul>';

            html += '</section><!-- /box -->';
        }
        //console.log("----",end.diff(start,'month'));
        //console.log(start,end);

        this.insertTarget.html(html);

        this.$days = $(".wrap .box ul li a",this.target);

        this.tmpRipple = new RippleManagerClass(this.insertTarget);
        this.tmpRipple.onCreate();
        this.tmpRipple.onResize(Util.getWindowSize());

        if(this.things.calenderSlide) {
            this.things.calenderSlide.onRemove();
            this.things.calenderSlide = null;
            delete this.things.calenderSlide;
        }
        if(this.isSlide){
            this.things.calenderSlide = new CalenderSlideClass(this.target,{itemWrapSelector:".wrap",itemSelector:".box"});
            this.things.calenderSlide.isBlockLoop = false;
            this.things.calenderSlide.isAutoStart = false;
            this.things.calenderSlide.slideItemNum = (Util.isBreakpoint)? 1 : 2;
            this.things.calenderSlide.onCreate();
            this.things.calenderSlide.onLoad();
            this.things.calenderSlide.onResize(Util.getWindowSize());
        }
    }

    onSetPrice(_data){
        //console.log(this.name,"onSetPrice",_data);
        if(!_data){
            $(".price",this.$days).text("");
        } else {
            for(let k in _data){
                const p = _data[k].airtiket_price;
                $(".price",this.$days.filter('[data-date="'+k+'"]')).text(Util.numberToPrice(parseInt(p)));
            }
        }
    }
}